<template>
  <c-button-menu
    ref="schoolsMenu"
    :loading="loading && !hasFetched['schools']"
    :label="schoolname"
    outline
    :menu-options="{
      listItems: schoolMenuItems,
    }"
    :menu-offset="[0, 10]"
    @before-show="openMenu"
  >
    <div class="tw-sticky tw-top-0 tw-z-20 tw-bg-white tw-p-4">
      <c-input
        v-model="searchVal"
        placeholder="Zoek school"
        debounce="300"
        autofocus
        dense
      />
    </div>
  </c-button-menu>
</template>

<script setup>
import CButtonMenu from "shared/components/wrappers/button/CButtonMenu.vue";
import { storeToRefs } from "pinia";
import { useGlobalSchoolDataStore } from "store/modules/globalSchoolDataStore";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { apiService } from "api/apiService";

// Router
const router = useRouter();

// Webmaster store
const globalSchoolDataStore = useGlobalSchoolDataStore();
const { fetchSchools } = globalSchoolDataStore;
const { schools, hasFetched } = storeToRefs(globalSchoolDataStore);

// Refs
const searchVal = ref("");
const loading = ref(false);
const schoolname = ref("");

const schoolMenuItems = computed(() => {
  return schools.value
    .filter(({ id, name }) => {
      const searchString = searchVal.value.toLowerCase();

      return (
        name.toLowerCase().includes(searchString) ||
        id.toString().includes(searchString)
      );
    })
    .map((school) => ({
      label: school.name,
      onClick: () => {
        loginAsSchool(school);
      },
    }));
});

onMounted(async () => {
  schoolname.value = localStorage.getItem("school_name");
});

const loginAsSchool = async (school = {}) => {
  const { id = null, name = "", school_hash = "" } = school || {};

  if (!id) {
    throw new Error("No school ID provided");
  }

  await apiService.put(`/api/impersonate/update-active-school`, {
    school_id: id,
  });

  localStorage.removeItem("employee_id");
  localStorage.removeItem("employee_shortage");

  localStorage.school_id = id;
  localStorage.school_name = `${name} (WM)`;
  localStorage.school_hash = school_hash;

  await router.push({ name: "LoginAsEmployee" });

  setTimeout(() => {
    window.location.reload();
  }, 100);
};

const openMenu = async () => {
  loading.value = true;
  await fetchSchools();
  loading.value = false;
};
</script>
